import { render, staticRenderFns } from "./Subdomains.vue?vue&type=template&id=c13df4f0&scoped=true&"
import script from "./Subdomains.vue?vue&type=script&lang=js&"
export * from "./Subdomains.vue?vue&type=script&lang=js&"
import style0 from "./Subdomains.vue?vue&type=style&index=0&id=c13df4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13df4f0",
  null
  
)

export default component.exports